import moment from "moment";
import type { Notification } from "../../types";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { Button } from "@/components/ui/button";
import { useHistory } from "react-router-dom";

dayjs.extend(relativeTime);

interface OpportunityCreatedProps {
  notification: Notification;
  updateNotificationStatus?: (params: {
    notification?: any;
    redirect?: boolean;
    otherSwitch?: boolean;
  }) => void;
}

export const OpportunityCreated = ({
  notification,
  updateNotificationStatus,
}: OpportunityCreatedProps) => {
  let history = useHistory();

  const handleMarkAsRead = () => {
    if (updateNotificationStatus) {
      updateNotificationStatus({
        notification: notification,
      });
    }
  };

  const handleViewOpportunity = () => {
    history.push(`/pipelines`);
    if (updateNotificationStatus) {
      updateNotificationStatus({
        notification: notification,
        redirect: true,
      });
    }
  };

  return (
    <div className="bg-primary/10 p-2 rounded-md w-full relative">
      <h2 className="text-sm font-medium">New Pipeline Opportunity Created</h2>
      <p className="text-xs text-muted-foreground mt-1">
        {notification.notification_message ||
          notification.content ||
          "A new pipeline opportunity has been created for the lead"}
      </p>
      <time
        className="text-xs absolute top-2 right-2"
        dateTime={notification.notification_time}
      >
        {dayjs(notification.notification_time).fromNow()}
      </time>
      <div className="mt-2">
        {notification.pipeline_opportunity_id && (
          <Button size="sm" onClick={handleViewOpportunity}>
            View Opportunity
          </Button>
        )}
        {!notification.read_status && (
          <Button
            size="sm"
            variant="outline"
            className="ml-2"
            onClick={handleMarkAsRead}
          >
            Mark as read
          </Button>
        )}
      </div>
    </div>
  );
};

